module.exports = __webpack_public_path__ + "static/hero-1053e760bb425814080a47a54ee2b9d0.jpg";